export default __webpack_public_path__ + "static/stay-wild-9ec22303da45eed72e059f76ec7081fd.otf";